const Header = () => (
  <div className='mb-12 max-lg:mb-8'>
    <h1 className='mb-4 font-bold text-h2 text-t-primary'>
      Card Verification Issues
    </h1>
  </div>
);

export default Header;
